import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";

import {
  topDataList,
} from "../../../../constants/SalesCustomerList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import axiosInstance from "../../../services/api/API";
import SalesListPage from "../SalesComponents/SalesListPage";
import Loader from "../../../customComponents/CustomLoader";

const CustomerList = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [leadAllocation,setLeadAllocation] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [ productdd, setProductdd ] = useState([])
  const [ makedd, setMakedd ] = useState([])
  const [searchQuery, setSearchQuery] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(true);


  const token = localStorage.getItem("authToken");
  const [filters, setFilters] = useState({});
  const [ filterFormData, setFilterFormData ] = useState({});

  const handleOnAddCustomerButton = () => {
    navigate(ROUTES_NAVIGATION.ADDSALESCUSTOMER);
  };


  useEffect(()=>{
    fethCustomerList()
  },[])


  const fethCustomerList = async (  page = 0, pageSize = 10) => {
  
    try {
      setLoading(true)
      const response = await axiosInstance.post('/salesvisit/visitlist', {
      
        orderBy: 'visit_id desc',
        page,
        pageSize,
        business_partner_id: 1,
        fromDate:filterFormData.fromDate || '', //2024-05-01 date fomat
        toDate:filterFormData.toDate || "",
      searchText: searchQuery || "" 
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });
  
      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  ,
        visit_date: new Date(item.visit_date).toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }) 
      }));
  
      const totalRecordsData = response?.data?.data?.totalRecords
        console.log(totalRecordsData, "RECORDS")
        setTotalRecords(totalRecordsData);
  
      setLeadAllocation(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching lead priorities:', error);
    }
    finally{
      setLoading(false)
    }
  };
  const handleCustomerDetails = () => {
    navigate(ROUTES_NAVIGATION.CUSTOMERDETAILSLIST)
  }

  const keyMapping = {
    "Lead No.": "lead_id",
    "Customer Name": "customer_name",
    "Contact No.": "mobile_no",
    "Visit Date & Time": "visit_date",
    "Transaction No":"transaction_code",
    "Customer Visit Type":"customer_visit_type_name",
    // "Visit Type": "visit_type_name",
    Color: "color_name",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "view", icon: eyeIcon, label: "View" },
    ],
  };

  const TABLE_HEADERS = [
    "Lead No.",
    "Customer Name",
    "Contact No.",
    "Visit Date & Time",
    "Transaction No",
    // "Visit Type",
    "Customer Visit Type",
    "Action",
  ];

  // const handlePageChange = (newPage) => {
  //   setCurrentPage(newPage);
  //   fethCustomerList(newPage);
  // };

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.CUSTOMERDETAILSLIST}`, { state: { data: rowData } });
  }

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITSALESCUSTOMER}`, { state: { data: rowData } });
  }


  // Handle Search
  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      fethCustomerList({ searchText: searchQuery });
    }
  };

  useEffect(() => {
    if (searchQuery === "") {
      fethCustomerList({ searchText: "" });
    }
  }, [searchQuery]);
  

  const handleClearSearch = () => {
    setSearchQuery(""); 
    fethCustomerList(0, 10); 
  };


  // Filter Inputs

  const clearFilter = () => {
    setFilterFormData({});
    fethCustomerList(0, 10, ""); 
  };
  


  const apiCallFunction = () =>{
    fethCustomerList()
  }



  const handleSearch=()=>{
fethCustomerList(0,10) 
  }


  const filtersInputs = [
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: false,
      gridClass: "col-lg-5",
  },
    {
        name: "toDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: false,
        gridClass: "col-lg-5",
    }
   
  ]


  return (


    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
        <SalesListPage
            headerTopText="Sales / Customer List"
            headerTitle="Customer List"
            addButtonTitle="Add Customer"
            uploadButtonTitle="Upload Customer"
            isUploadButtonRequired="false"
            listTitle="All Customers"
            topDetailsList={topDataList}
            tableData={leadAllocation}
            tableHeaders={TABLE_HEADERS}
            keyMapping={keyMapping}
            handleOnAddButton={handleOnAddCustomerButton}
            handleOnUploadButton={() => {}}
            // handleViewButton={handleCustomerDetails}
            onEdit={handleEdit}
            totalRecords={totalRecords} 
            currentPage={currentPage}
            totalPages={totalPages}
            // onPageChange={handlePageChange} 
            handleViewButton={handleViewDetails}
            apiCallFunction={apiCallFunction}
            handleSearchChange={handleSearchChange}
            handleKeyPress={handleKeyPress}
            searchplaceholder="Search by Customer Name"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleClearSearch={handleClearSearch}
      
            isFilterRequired= {true}

            handleFormSubmit={handleSearch}
            filterFormData={filterFormData}
            setFilterFormData={setFilterFormData}
            filterInputs={filtersInputs}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleClear={clearFilter}
          />
   </div>
    )}
    </div>

    // <div>

    //   {
    //     loading ? (
    //       <Loader />
    //     )
    //     :
    //     (
    //       <SalesListPage
    //         headerTopText="Sales / Customer List"
    //         headerTitle="Customer List"
    //         addButtonTitle="Add Customer"
    //         uploadButtonTitle="Upload Customer"
    //         isUploadButtonRequired="false"
    //         listTitle="All Customers"
    //         topDetailsList={topDataList}
    //         tableData={leadAllocation}
    //         tableHeaders={TABLE_HEADERS}
    //         keyMapping={keyMapping}
    //         handleOnAddButton={handleOnAddCustomerButton}
    //         handleOnUploadButton={() => {}}
    //         // handleViewButton={handleCustomerDetails}
    //         onEdit={handleEdit}
    //         totalRecords={totalRecords} 
    //         currentPage={currentPage}
    //         totalPages={totalPages}
    //         onPageChange={handlePageChange} 
    //         handleViewButton={handleViewDetails}
    //         apiCallFunction={apiCallFunction}
    //         handleSearchChange={handleSearchChange}
    //         handleKeyPress={handleKeyPress}
    //         searchplaceholder="Search by Customer Name"
    //         searchQuery={searchQuery}
    //         setSearchQuery={setSearchQuery}
      
    //         isFilterRequired= {true}
      
    //         filterFormData={filterFormData}
    //         setFilterFormData={setFilterFormData}
    //         filterInputs={filtersInputs}
    //         validationErrors={validationErrors}
    //         setValidationErrors={setValidationErrors}
    //         handleClear={clearFilter}
    //       />
    //     )
    //   }

    // </div>

  );
};

export default CustomerList;